// Single source of truth for the analytics score-band boundary values. These
// reuse the QC bands (98 / 95) so the two surfaces stay aligned. There are
// three bands: Exemplary (≥98%), Meets Expectations (95–97.9%), and
// Unsatisfactory (everything below 95%).
//
// `*_LTE` constants encode the upper inclusive bound for the API's score_lte
// filter. We subtract an epsilon so a band like "Unsatisfactory" (< 95%)
// surfaces over the API as score_lte=0.9499..., which doesn't include 0.95.
// Keep this epsilon centralized so the chip count rule (< 0.95) and the API
// param can never drift apart.

import { SCORE_BAND_EXEMPLARY_MIN, SCORE_BAND_MEETS_MIN } from '@/pages/qc/utils';

const SCORE_BAND_EPSILON = 0.000001;

export { SCORE_BAND_EPSILON, SCORE_BAND_EXEMPLARY_MIN, SCORE_BAND_MEETS_MIN };

/** Upper-bound for the "Unsatisfactory" quick filter (< 0.95). */
export const COACHING_SCORE_LTE = SCORE_BAND_MEETS_MIN - SCORE_BAND_EPSILON;
